import { DefaultHeaderFrSystm, DefaultHeaderToSystm } from "src/const"
import { API_PATH } from "src/const/api-urls"
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env"
import { BaseResponse } from "src/interface"
import { IRequestInitPayment, IRequestPaymentID } from "src/interface/typePay"
import { createCreDtTm, createMSGID } from "src/utils/helper"
import httpsService from "./httpsService"

export const RequestPaymentId = (data: IRequestPaymentID, frSystm?: string) => {
    const param = { msgId: createMSGID(frSystm || FR_HEADER) };
    const header = {
      frSystm: frSystm || FR_HEADER,
      toSystm: DefaultHeaderToSystm,
      creDtTm: createCreDtTm(),
    };
    return httpsService.post<IRequestPaymentID, BaseResponse<any>>(API_PATH.CREATE_DATA_INIT_PAYMENT_V2, data, {
        headers: header,
        params: param,
    })
}

